// extracted by mini-css-extract-plugin
export var wrapper = "style-module--wrapper--Lwz1W";
export var content = "style-module--content--xSfP+";
export var header = "style-module--header--9PwI5";